import { Drawer, Portal, CloseButton } from '@chakra-ui/react';
import ViewContent from './view-content';
import useDialogCleanup from '@/lib/hooks/use-dialog-cleanup';
import '@/styles/print.css';

interface Props {
  isOpen: boolean;
  onClose(): void;
  content: any;
  drawerId?: string;
  autoOpenPrintDialog?: boolean;
}

export default function ContentDrawer({
  isOpen,
  onClose,
  content,
  drawerId,
  autoOpenPrintDialog,
}: Props) {
  useDialogCleanup(isOpen);
  return (
    <Drawer.Root
      id={`view-content-drawer-${drawerId}`}
      size='xl'
      placement='end'
      lazyMount
      unmountOnExit
      open={isOpen}
      onOpenChange={(details) => {
        if (!details.open) onClose();
      }}
    >
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content bg='bg.panel' shadow='lg'>
            <Drawer.CloseTrigger asChild>
              <CloseButton
                size='sm'
                position='absolute'
                top={4}
                insetEnd={4}
                zIndex={2}
              />
            </Drawer.CloseTrigger>
            <Drawer.Body>
              <div data-print-target>
                {content && (
                  <ViewContent
                    data={content}
                    inDrawer
                    onClose={onClose}
                    autoOpenPrintDialog={autoOpenPrintDialog}
                  />
                )}
              </div>
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
}
